import { render, staticRenderFns } from "./ProjectNavigationMainItem.vue?vue&type=template&id=7f19f76e"
import script from "./ProjectNavigationMainItem.vue?vue&type=script&lang=js"
export * from "./ProjectNavigationMainItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports